"use client";

import { AppLink } from "@/ui/app-link/app-link";

interface GlowButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: "gold" | "ghost";
  className?: string;
}

export function GlowButton(props: GlowButtonProps) {
  const isGold = props.variant !== "ghost";

  const base = isGold
    ? "bg-v2-gold text-v2-black font-mono text-xs font-bold uppercase tracking-[2px]"
    : "bg-v2-cream/10 text-v2-cream font-mono text-xs font-bold uppercase tracking-[2px]";

  const inner = `relative z-10 rounded-full px-10 py-4 transition-all duration-200 ${base} ${props.className ?? ""}`;

  const content = (
    <div className="group relative inline-block">
      {props.href ? (
        <AppLink href={props.href} className={inner}>
          {props.children}
        </AppLink>
      ) : (
        <button type="button" className={inner}>
          {props.children}
        </button>
      )}
      <div
        className="pointer-events-none absolute -inset-1 rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background: isGold
            ? "radial-gradient(ellipse at 50% 100%, rgba(201,168,76,0.3) 0%, transparent 70%)"
            : "radial-gradient(ellipse at 50% 100%, rgba(245,240,230,0.1) 0%, transparent 70%)",
        }}
      />
    </div>
  );

  return content;
}
